module.exports = __webpack_public_path__ + "media/images/lb/289-2e20b3575e77476342562a91896302b9.svg";